import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DsBannerComponent } from './components/ds-banner/ds-banner.component';
import { DsServicesComponent } from './components/ds-services/ds-services.component';
import { DsServiceListingComponent } from './components/ds-service-listing/ds-service-listing.component';
import { ApplicationService } from 'app/services/application.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { PartnershipDialogComponent } from '../partnership-dialog/partnership-dialog.component';

@Component({
    selector: 'app-digital-services',
    standalone: true,
    imports: [
        HeaderComponent,
        FooterComponent,
        TranslateModule,
        CommonModule,
        DsBannerComponent,
        DsServicesComponent,
        DsServiceListingComponent,
    ],
    templateUrl: './digital-services.component.html',
    styleUrl: './digital-services.component.scss',
})
export class DigitalServicesComponent implements OnInit {
    selectedLanguage: string = 'en';
    digiServiceData: any[] = [];

    constructor(
        private applicationService: ApplicationService,
        private toastr: ToastrService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.getDigiServiceData();
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    getDigiServiceData() {
        this.applicationService.getDigiServiceData().subscribe({
            next: (res) => {
                this.digiServiceData = res;
            },
            error: (err) => {
                this.toastr.error(err.message);
            },
        });
    }

    openDigiPartnershipDialog(data) {
        let digiPartnershipData = data;
        this.dialog.open(PartnershipDialogComponent, {
            width: '869px',
            disableClose: true,
            data: {
                partnership: digiPartnershipData,
                source: 'digital-services',
            },
        });
    }
}
